<template>
	<div>
		<template v-if="!isLoading" >

      <!-- PrivateScamas are found-->
      <v-row 
        v-if="scamas.length > 0"
        no-gutters 
        justify="center"
      >
        <v-col
          v-for="scama in scamas"
          :key="scama.id"
          style="margin:4px 10px; !important" 
        >
          <linkCard 
            @wannaDelete="popupDelete($event)"
            :id="scama.id"
            :title="scama.name"
            :photo="scama.photo"
            :link="scama.link"
          />
        </v-col>
      </v-row>

      <!-- no PrivateScamas -->
      <template v-else>
        <v-alert
          prominent
          text
          type="info"
        >
          {{ $t("prvScama.links.noScamas") }}
        </v-alert>
        <center>
          <v-btn
            large
            elevation="8"
            color="primary"
            @click="redirectCreate"
          >
            <v-icon left>
              mdi-plus-circle
            </v-icon>
            {{ $t("prvScama.links.createNewScama") }}
          </v-btn>
        </center>
      </template>
		</template>
		
	  <template v-else>	<!-- Loading ... -->
    		<center>
	    		<v-progress-circular
			      :size="80"
			      color="primary"
			      indeterminate
	    		></v-progress-circular>
  		</center>
		</template >

    <!--Alert popup on delete -->
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="completeWord headline">{{ $t("prvScama.links.sureDelete?") }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false"> {{ $t("prvScama.links.disagree") }} </v-btn>
          <v-btn color="error" @click="deletePrivateScama"> {{ $t("prvScama.links.agree") }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
	</div>
  
</template>


<script>
// @ is an alias to /src
import linkCard from '@/components/private-scamas/linkCard.vue'
import PrivateScama from "@/apis/PrivateScama";

export default {
  name: 'prvIndex',
  components: {
    linkCard
  },

  data(){
  	return {
  		scamas: [],
  		isLoading: true,
      dialog: false,
      wanntedScama: Number,
  	}
  },
  
  methods : {

    /**
    * Get all private scamas
    */
  	getPrivateScamas() {
  		//Start Loading ...
      this.isLoading = true;

  		PrivateScama.getAll()
  		.then(response => {
  			this.scamas = response.data;

  			//Finish loading
        this.isLoading = false;
  		})
  	},

    /**
    * Ask if wanted to delete scama
    */
    popupDelete(id){
      this.dialog = true;
      this.wanntedScama = id;
    },

    /**
    * Delete private scama
    */
    deletePrivateScama(){
      this.dialog = false;
      PrivateScama.delete(this.wanntedScama)
      .then(response => {
        this.scamas.splice(this.scamas.findIndex(item => item.id === this.wanntedScama), 1)
      })
    },

    /**
    * Redirect to Create PrivateScama
    */
    redirectCreate(){
      this.$router.push({path : 'create'});
    }
  },
  mounted(){
  	this.getPrivateScamas();
  }
};
</script>
